export const GunForSaleCondition = {
  Excellent: 'excellent',
  Good: 'good',
  Fair: 'fair',
} as const;

export default GunForSaleCondition;
